import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { href: "#chi-sono", label: "Chi Sono" },
  { href: "#patologie", label: "Patologie" },
  { href: "#seconda-opinione", label: "Seconda Opinione" },
  { href: "#ricerca", label: "Ricerca" },
  { href: "#sedi", label: "Sedi" },
  { href: "#educazione", label: "Educazione" },
  { href: "#contatti", label: "Contatti" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background,backdrop-filter,border-color] duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F9F8F6]/75 border-b border-[#E5E1D8]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center" data-testid="logo-link">
          <span className="flex flex-col leading-tight">
            <span className="font-serif-display text-[18px] tracking-tight text-[#1A1D1A]">
              Dott. Manuel Gotti
            </span>
            <span className="eyebrow text-[10px] mt-[2px]">Ematologo</span>
          </span>
        </a>

        <nav className="hidden xl:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-[#1A1D1A]/80 hover:text-[#8A6D56] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden xl:block">
          <a
            href="#prenota"
            data-testid="prenota-ora-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#8A6D56] text-white text-sm font-medium hover:bg-[#735A47] transition-colors duration-200"
          >
            Prenota una visita
            <span aria-hidden>→</span>
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="xl:hidden w-10 h-10 grid place-items-center rounded-full border border-[#E5E1D8] bg-white"
          aria-label="Apri menu"
        >
          <span className="flex flex-col gap-[5px]">
            <span className={`h-[1.5px] w-5 bg-[#1A1D1A] transition-transform ${open ? "rotate-45 translate-y-[6.5px]" : ""}`} />
            <span className={`h-[1.5px] w-5 bg-[#1A1D1A] transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`h-[1.5px] w-5 bg-[#1A1D1A] transition-transform ${open ? "-rotate-45 -translate-y-[6.5px]" : ""}`} />
          </span>
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
            className="lg:hidden border-t border-[#E5E1D8] bg-[#F9F8F6]"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-base font-medium text-[#1A1D1A] py-2"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#prenota"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#8A6D56] text-white text-sm font-medium"
              >
                Prenota una visita
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
